export enum RadiationArticleCodes {
  RELATED_TOPIC = 'radiation_related_topics_detail',
  WHAT_NEXT = 'radiation_what_next_detail',
}
